<template>
  <div class="footer-box" @contextmenu.prevent.capture>
    <div class="container flex-box">
      <div class="logo-left">
        <img class="left-img1" src="../assets/image/common/eol-logo.png" />
        <img class="left-img2" src="../assets/image/common/szzyk-img.png" />
      </div>
      <div class="company-box">
        <p class="name">北京中教互联教育科技有限公司</p>
        <p>地址：北京市海淀区文慧园北路9号今典花园9号楼-教育在线</p>
      </div>
      <div class="contact-box">
        <div class="contact-left">
          <div class="contact-title">业务合作：</div>
          <div class="contact-line">
            <p>王老师 13161510966</p>
          </div>
        </div>
        <div class="contact-right">
          <img src="../assets/image/common/shou.png" alt="">
        </div>
      </div>

    </div>
    <div class="copyright">
      <span>版权所有</span>
      <!-- <span><a href="https://www.eol.cn" target="_blank">教育在线</a></span> -->
      <span>北京中教互联教育科技有限公司</span>
      <a href="http://www.eol.cn/html/cer.net/icp.htm" target="_blank">京ICP证140769号</a> |
      <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">京ICP备2022007846号-1 </a> |
      <a href="http://img.eol.cn/images/indexnew/www1024.jpg" target="_blank">京网文[2014]2106-306号</a> |
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020236" target="_blank">京公网安备 11010802020236号</a>
    </div>
  </div>
</template>

<script>
import services from "../assets/js/services"
export default {
  name: 'Header',
  components: {
  },
  data () {
    return {
      services,
    };
  },
}
</script>

<style lang="less" scoped>
.copyright {
    height: 40px;
    background: #E0E3E8;
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    span,
    a {
        display: inline-block;
        vertical-align: top;
        margin: 0 5px;
        font-size: 12px;
        color: #696969;
        transition: color 0.3s;
    }
    a:hover {
        color: #ee373d;
    }
}
.footer-box {
    background: #EDF0F3;
    position: relative;
}
.flex-box {
    display: flex;
    height: 118px;
    justify-content: space-between;
    align-items: center;
    .logo-left {
      display: flex;
      align-items: center;
        .left-img1 {
          width: 160px;
          height: auto;
          margin-right: 34px;
        }
        .left-img2 {
          width: 143px;
          height: auto;
        }
    }
    .company-box {
        color: #696969;
        font-size: 14px;
        line-height: 32px;
        .name {
          color: #333333;
          font-size: 16px;
        }
    }
    .contact-box {
        position: relative;
        .contact-left {
            .contact-title {
                font-weight: bold;
                font-size: 14px;
                color: #333333;
            }
            .contact-line {
                margin-top:4px;
                font-size: 14px;
                color: #696969;
                line-height: 22px;
            }
        }
        .contact-right {
            width: 42px;
            position: absolute;
            top: -8px;
            right: 0;
            img {
                width: 100%;
                height: auto;
            }
        }
    }
}

@media (min-device-width: 320px) and (max-width: 689px),
    (max-device-width: 480px) {
    .footer-box {
        display: none;
    }
}
</style>
